import { AaaIconComponent } from './aaa.icon'
import { ArrowIconComponent } from './arrow.icon'
import { DrrMapPinComponent } from './map-pin.component'
import { CloseIconComponent } from './close.icon'
import { PositionIconComponent } from './position.icon'
import { BreakdownLocationPinIconComponent } from './breakdown-location-pin.icon'
import { TowLocationPinIconComponent } from './tow-location-pin.icon'
import { ChargingLevelIconComponent } from './charging-level.icon';

import { EvConnectorsIcons } from './ev-connectors'
import { HandIconComponent } from './hand.icon';
import { ArrowRightIconComponent } from './arrow-right.icon'
import { USFlagIconComponent } from './us-flag.icon'
import { CAFlagIconComponent } from './ca-flag.icon'
import { AaaLogoIconComponent } from './aaa-logo.icon'


export const icons = [
  AaaIconComponent,
  ArrowIconComponent,
  CloseIconComponent,
  HandIconComponent,
  PositionIconComponent,
  BreakdownLocationPinIconComponent,
  TowLocationPinIconComponent,
  ChargingLevelIconComponent,
  ArrowRightIconComponent,
  USFlagIconComponent,
  CAFlagIconComponent,
  DrrMapPinComponent,
  ...EvConnectorsIcons(),
]

export const iconModules = [
  AaaLogoIconComponent,
];

export { registerIonicons } from './icon.providers';
